import { id } from 'vuetify/locale'

export const customId = {
  ...id,
  datePicker: {
    title: 'Pilih Tanggal',
  },
  dataTable: {
    itemsPerPageText: 'Item per halaman:',
    ariaLabel: {
      sortDescending: ': Diurutkan menurun.',
      sortAscending: ': Diurutkan menaik.',
      sortNone: ': Tidak diurutkan.',
      activateNone: 'Aktifkan untuk hapus pengurutan.',
      activateDescending: 'Aktifkan untuk urutan menurun.',
      activateAscending: 'Aktifkan untuk urutan menaik.',
    },
    sortBy: 'Urutkan berdasarkan',
  },
  noDataText: 'Tidak ada data tersedia',
  loading: 'Memuat...',
}
